/* * * ./app/Ticket/Components/ticket.component.ts * * */
// Imports
import { Component, AfterViewChecked, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Card } from '../Model/card';
import { TicketService } from '../../Ticket/Services/ticket.service';


// Component decorator
@Component({
    moduleId: "module.id",
    selector: 'my-payment',
    template: require('./views/payment.component.html')
})
// Ticket class
export class PaymentComponent implements AfterViewChecked {

    pay: {};
    ticket_data: {};
    errorMessage: string;
    loading: boolean;
    payment_processing: boolean;
    client: {};

    email: string;

    card = new Card();

    // Constructor
    constructor(private router: Router, private ticketService: TicketService) {}

    ngOnInit() {
        this.ticket_data = this.ticketService.ticket_data;
        this.client = this.ticketService.client;
    }

    payTicket() {
        this.errorMessage = '';

        let expiry_date = this.card.expiry_month + '/' + this.card.expiry_year;

        let amount = this.ticket_data['ticket_details']['current_charge'];

        this.payment_processing = true;

        this.ticketService.payTicket(
            this.ticket_data['ticket_details']['ticket_no'],
            this.ticket_data['ticket_details']['vrm'],
            this.card.first_name,
            this.card.last_name,
            this.card.card_number,
            this.card.cvc,
            expiry_date,
            amount,
            this.email
        )
        .subscribe(
            pay => { this.pay = pay, this.updateTicketInfo()},
            error => {this.errorMessage = error, this.payment_processing = false},
            () => this.payment_processing = false
        );
    }

    updateTicketInfo() {
        if (!this.pay['error']) {
            this.card.first_name = '';
            this.card.last_name = '';
            this.card.card_number = '';
            this.card.cvc = '';
            this.email = '';
            this.ticketService.success_message = true;
            this.ticketService.ticket_data['ticket_details']['is_paid'] = 1;
            let link = ['ticket-search'];
            this.router.navigate(link);
        }
    }

    ticketRoute() {
        let link = ['ticket-search'];
        this.router.navigate(link);
    }

    cardForm: NgForm;
    @ViewChild('cardForm') currentForm: NgForm;

    ngAfterViewChecked() {
        this.formChanged();
    }

    formChanged() {
        if (this.currentForm === this.cardForm) { return; }
        this.cardForm = this.currentForm;
        if (this.cardForm) {
          this.cardForm.valueChanges
            .subscribe(data => this.onValueChanged(data));
        }
    }

    onValueChanged(data?: any) {
        if (!this.cardForm) { return; }
        const form = this.cardForm.form;

        for (const field in this.formErrors) {
            // clear previous error message (if any)
            this.formErrors[field] = '';
            const control = form.get(field);

            if (control && control.dirty && !control.valid) {
                const messages = this.validationMessages[field];
                for (const key in control.errors) {
                    this.formErrors[field] += messages[key] + ' ';
                }
            }
        }
    }

    formErrors = {
        'first_name': '',
        'last_name': '',
        'card_number': '',
        'expiry_month': '',
        'expiry_year': '',
        'cvc': '',
        'email': ''
    };

    validationMessages = {
      'first_name': {
        'required':      'First Name is required.',
      },
      'last_name': {
        'required':      'Last Name is required.'
      },
      'card_number': {
        'required':      'Credit Card is required.',
        'minlength':     'Credit Card must be at least 13 characters long.',
        'maxlength':     'Credit Card cannot be more than 19 characters long.',
        'isNumber':      'Only digits.'
      },
      'expiry_month': {
        'required':      'Expiry month is required.',
      },
      'expiry_year': {
        'required':      'Expiry year is required.',
      },
      'cvc': {
        'required':      'CVC is required.',
        'minlength':     'CVC must be at least 3 characters long.',
        'maxlength':     'CVC cannot be more than 4 characters long.',
        'isNumber':      'Only digits.'
      },
      'email': {
        'pattern':       'Needed to send confirmation, make sure it is the correct email.'
      }
    };

 }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Payment/Components/payment.component.ts